import React from 'react';
import style from './style.scss';
import NeedOffersByCategory from 'components/partials/need-offer-by-category';
import {RightStickerContainer} from 'components/partials/right-sticker';
import {Demands, Categories} from 'api';
import {Link} from 'react-router-dom';
import ItemDemand from './ItemDemand.jsx';
import {ShowIf} from 'components/utils';
import {parse} from 'qs';
import {withRouter} from 'react-router';
import {LoadingPage} from 'components/loading-page';
import ReactPaginate from 'react-paginate';

class ListDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      categories: [],
      count: 0,
      skip: 0,
      limit: 10,
      isLoading: false
    };
    this.query = parse(this.props.location.search.substr(1));
    this.getDemand = this.getDemand.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
  }

  componentDidMount() {
    this.getDemand();
  }

  componentWillReceiveProps(nextProps) {
    this.query = parse(nextProps.location.search.substr(1));
    this.getDemand();
  }

  getDemand() {
    let params = {
      filter: {
        where: {
          isApprove: true
        }
      }
    };
    let countDemand = null;
    if (this.query.category) {
      params.id = this.query.category;
      countDemand = Categories.actions.countDemand.request(params);
    } else {
      countDemand = Demands.actions.count.request(params);
    }
    this.setState({isLoading: true, data: []});
    this.getCategories();
    countDemand.then((response) => {
      this.setState({count: response.data.count, isLoading: false});
      this.getList();
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  getCategories() {
    Categories.actions.categoryDemand.request().then((response) => {
      response.data.sort((a, b) => {
        return b.countApprovedDemands - a.countApprovedDemands;
      });
      this.setState({categories: response.data.slice(0, 6)});
    });
  }

  getList() {
    let params = {
      filter: {
        limit: this.state.limit,
        skip: this.state.skip,
        where: {
          isApprove: true
        }
      }
    };
    let listDemand = null;
    if (this.query.category) {
      params.id = this.query.category;
      listDemand = Categories.actions.demands.request(params);
    } else {
      listDemand = Demands.actions.list.request(params);
    }
    this.setState({isLoading: true});
    listDemand.then(response => {
      let demands = [];
      response.data.map((item, idx) => {
        demands.push(item);
      });
      this.setState({data: demands, isLoading: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  onPageChange(page) {
    this.setState({skip: page.selected * 10}, () => {
      this.getList();
    });
  }

  render() {
    const {count, limit, isLoading} = this.state;
    const totalPage = Math.ceil(count / limit);
    return (
      <section className="center list-demand-container">
        <LoadingPage isShow={isLoading} />
        <ShowIf condition={this.state.categories.length > 0}>
          <div className="wrap-need-offer-by-category">
            <section className="need-offer-by-category-container">
              <div className="need-offer-by-category-wrap">
                <div className="content-justify need-offer-by-category-title-wrap">
                  <h2 className="need-offer-by-category-title">Nhu cầu cần kết nối</h2>
                  <Link className="view-more-link" to="demands">Xem tất cả</Link>
                </div>
                <div className="wrap-item">
                  {
                    this.state.categories.map((item, i) => {
                      return (
                        <NeedOffersByCategory {...item} key={i}/>
                      );
                    })
                  }
                </div>
              </div>
            </section>
          </div>
        </ShowIf>
        <div className="list-demand-wrap">
          <div className="list-demand-content-left">
            <div className="list-demand">
              {
                this.state.data.map((item, i) => {
                  return (
                    <ItemDemand key={i} {...item}/>
                  );
                })
              }
            </div>
          </div>
          <div className="list-demand-content-right">
            <RightStickerContainer>
              <form className="list-demand-filter">
                <p className="list-demand-filter-label">Từ khóa nhu cầu</p>
                <input type="text" placeholder="Nhập tên sản phẩm..." className="list-demand-filter-input"/>
                <p className="list-demand-filter-label">Lĩnh vực</p>
                <input type="text" placeholder="Nhập tên sản phẩm..." className="list-demand-filter-input"/>
                <button className="list-demand-filter-button">Tìm kiếm</button>
              </form>
            </RightStickerContainer>
          </div>
        </div>
        <ShowIf condition={this.state.data.length > 0}>
          <ReactPaginate previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={totalPage -1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.onPageChange}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </ShowIf>
      </section>
    );
  }
}

export default withRouter(ListDemand);



// WEBPACK FOOTER //
// ./components/demand/ListDemand.jsx